// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3g1_G","location":"Header_location__1NuHX"};